export const scoreColor = (v) => {
  if (v >= 80) return "#16A34A";
  if (v >= 60) return "#EA580C";
  return "#E11D48";
};

export const riskColor = (level) => {
  const l = (level || "").toLowerCase();
  if (l === "high") return "#E11D48";
  if (l === "medium") return "#EA580C";
  return "#16A34A";
};

export const gradeBand = (pct) => {
  if (pct >= 70) return "First";
  if (pct >= 60) return "2:1";
  if (pct >= 50) return "2:2";
  if (pct >= 40) return "Third";
  return "Fail";
};

export const readyVerdict = (v) => {
  if (v >= 85) return { dot: "#16A34A", emoji: "🟢", label: "Ready", sub: "Ready to submit", color: "#15803D" };
  if (v >= 65) return { dot: "#EA580C", emoji: "🟡", label: "Almost Ready", sub: "A few fixes first", color: "#B45309" };
  return { dot: "#E11D48", emoji: "🔴", label: "Needs Improvement", sub: "More work needed", color: "#B91C1C" };
};

// Performance bands for student-facing Assessment Criteria.
// Colour-coded, descriptive labels instead of raw percentages.
export const performanceBand = (pct) => {
  const v = Math.max(0, Math.min(100, Number(pct) || 0));
  if (v >= 85) return {
    label: "Excellent", key: "excellent",
    color: "#047857", bg: "#D1FAE5", border: "#A7F3D0", bar: "#10B981",
  };
  if (v >= 70) return {
    label: "Good", key: "good",
    color: "#1D4ED8", bg: "#DBEAFE", border: "#BFDBFE", bar: "#3B82F6",
  };
  if (v >= 60) return {
    label: "Satisfactory", key: "satisfactory",
    color: "#A16207", bg: "#FEF9C3", border: "#FDE68A", bar: "#EAB308",
  };
  if (v >= 50) return {
    label: "Needs Improvement", key: "needs_improvement",
    color: "#C2410C", bg: "#FFEDD5", border: "#FED7AA", bar: "#F97316",
  };
  return {
    label: "Significant Improvement Required", key: "significant",
    color: "#B91C1C", bg: "#FEE2E2", border: "#FECACA", bar: "#EF4444",
  };
};

export const nextBoundary = (pct) => {
  const T = [
    { v: 40, n: "a Third" }, { v: 50, n: "a 2:2" },
    { v: 60, n: "a 2:1" }, { v: 70, n: "a First" },
  ];
  const next = T.find((t) => t.v > pct);
  if (!next) return { text: "Comfortably in the First-class range", away: 0 };
  return { text: `${next.v - pct}% away from ${next.n}`, away: next.v - pct, name: next.n };
};
